import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

import * as Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueSmoothScroll from 'vue3-smooth-scroll';
import Notifications from '@kyvg/vue3-notification';
import velocity from 'velocity-animate'

window.mortgage = {
    aInternal: 0,
    aListener: function(val) {},
    set price(val) {
        this.aInternal = val;
        this.aListener(val);
    },
    get price() {
        return this.aInternal;
    },
    registerListener: function(listener) {
        this.aListener = listener;
        //console.log(`%c window.mortgage(registerListener) this.aListener = `, 'color: lime', this.aListener);
    },
};
import DFlatInfo from '@components/organisms/DFlatInfo.vue';
import DFlatMortgage from '@components/organisms/DFlatMortgage.vue';
import DFlatFurnishCalc from "@components/molecules/DFlatFurnishCalc.vue";

document.flatInfoApp = null;
$(window).on('load', function(e) {
    try {
        Vue.createApp({components: {DFlatInfo}}).use(VueAxios, axios).use(VueSmoothScroll).use(Notifications, { velocity }).mount('.d-flat__section._top');
        const flatData = window.flat_info && window.flat_data
            ? Object.assign({}, window.flat_info, window.flat_data)
            : window.flat_info ? window.flat_info : window.flat_data;
        if (flatData) {
            if (!flatData.is_sold && !flatData.price_request) {
                Vue.createApp({components: {DFlatMortgage}}).use(VueAxios, axios).mount('.d-flat-mortgage__content');
            }
            else {
                document.querySelector('.d-flat__section._mortgage').remove();
            }
            if (flat_data.furnish_calc) {
                Vue.createApp({components: {DFlatFurnishCalc}}).use(VueAxios, axios).mount('.d-flat__furnish');
            } else {
                document.querySelector('.d-flat__section._furnish').remove();
            }
        }
    } catch (e) {
        console.error(e);
    }

});

new Swiper('[data-similar-flat]', {
    a11y: false,
    loop: false,
    loopedSlides: 4,
    keyboard: {
        enabled: true,
        onlyInViewport: true,
    },
    slidesPerView: 'auto',
    spaceBetween: 32,
    navigation: {
        nextEl: '.flatSimilar._next',
        prevEl: '.flatSimilar._prev',
    },
    breakpoints: {
        320: {
            spaceBetween: 12,
        },
        768: {
            spaceBetween: 32,
        },
        1920: {
            slidesPerView: 3,
        },
    },
});

